import React, { Component } from 'react'
import {
  DESKTOP_BREAKPOINT
} from "manager/views/components/Settlement/constants"
import StyledButton from "common/views/components/StyledButton"
import styled from "styled-components"
import {SettlementPadding} from "manager/views/components/Settlement/Common/SettlementCard"

const Container = styled(SettlementPadding)`
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
`

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  
  flex-grow: 1;
  margin: 20px 0px;
  @media screen and ${DESKTOP_BREAKPOINT} {
    flex-grow: 0;
    flex-basis: 30%;
    margin: 20px 0px;
  }
`

const CancelA = styled.a`
  text-align: center;
  flex: 1 1 0;
`

const Button = styled(StyledButton)`
  align-items: stretch;
  flex: 2 1 0;
  @media screen and ${DESKTOP_BREAKPOINT} {
    flex: 1 1 0;
  }
`

class FooterContainer extends Component {
  render() {
    const {cancelOnClick, disabled, buttonOnClick, buttonName} = this.props

    return (
      <Container paddingRight='83px'>
        <ButtonsWrapper>
          <CancelA onClick={cancelOnClick}>Cancel</CancelA>
          <Button disabled={disabled}
                  onClick={buttonOnClick}
                  oldColorPalette={true}
                  largerFont={true}
                  positive
                  paddingTopBottom={10}>{buttonName}</Button>
        </ButtonsWrapper>
      </Container>
    )
  }
}
export default FooterContainer

